
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gp/fa",
      function () {
        return require("private-next-pages/gp/fa/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gp/fa"])
      });
    }
  